import { render, staticRenderFns } from "./author.vue?vue&type=template&id=e2c005ea&scoped=true"
import script from "./author.vue?vue&type=script&lang=js"
export * from "./author.vue?vue&type=script&lang=js"
import style0 from "./author.vue?vue&type=style&index=0&id=e2c005ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c005ea",
  null
  
)

export default component.exports